module.exports = {"Airset":"Airset","No-Bake":"No-Bake","Oil":"Oil","Other":"Other","Shell":"Shell"}


//////////////////
// WEBPACK FOOTER
// ./src/config/coreProcess.json
// module id = 5254
// module chunks = 1